var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuxembourg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_70462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.8002 19.4524C15.1021 19.4524 19.4002 15.1544 19.4002 9.85244C19.4002 4.55051 15.1021 0.252441 9.8002 0.252441C4.49826 0.252441 0.200195 4.55051 0.200195 9.85244C0.200195 15.1544 4.49826 19.4524 9.8002 19.4524Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79976 0.252441C5.6721 0.252441 2.15329 2.85764 0.796875 6.51333H18.8027C17.4462 2.85764 13.9274 0.252441 9.79976 0.252441Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79976 19.4523C13.9274 19.4523 17.4462 16.8471 18.8027 13.1914H0.796875C2.15329 16.8471 5.6721 19.4523 9.79976 19.4523Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_70462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(0.200195 0.252441)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuxembourg);
export default __webpack_public_path__ + "static/media/Luxembourg.31f5278dd59a58a930506ca39be0f8e2.svg";
export { ForwardRef as ReactComponent };